import { SEARCH_MIN_PRICE_DEFAULT, SEARCH_MAX_PRICE_DEFAULT } from './defaults';
import { isPropertyStatusForRent } from './isPropertyStatusForRent';

export const getMinAndMaxPriceOnPropertyStatusChange = ({
  minPrice,
  maxPrice,
  previousPropertyStatus,
  newPropertyStatus,
}: {
  minPrice: string;
  maxPrice: string;
  previousPropertyStatus: string;
  newPropertyStatus: string;
}): { minPrice: string; maxPrice: string } => {
  const propertyStatusChangedToRent =
    !isPropertyStatusForRent(previousPropertyStatus) && isPropertyStatusForRent(newPropertyStatus);

  const propertyStatusChangedFromRent =
    isPropertyStatusForRent(previousPropertyStatus) && !isPropertyStatusForRent(newPropertyStatus);

  if (propertyStatusChangedToRent || propertyStatusChangedFromRent) {
    // Set min and max price to default because RENT has different budget options from the other market status'
    return { minPrice: SEARCH_MIN_PRICE_DEFAULT, maxPrice: SEARCH_MAX_PRICE_DEFAULT };
  }

  return { minPrice, maxPrice };
};
